import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash.debounce';
import $ from 'jquery';

import Search from '../search';

import { parseGeoCoderResult, getSuggestUrl, getGeoCodingUrl } from './utils';

class Geocoder extends PureComponent {

  static propTypes = {
    hereAppId: PropTypes.string,
    hereAppCode: PropTypes.string,
    center: PropTypes.arrayOf(PropTypes.number),
    country: PropTypes.string,
    radius: PropTypes.number,
    onSelect: PropTypes.func,
    notFoundMessage: PropTypes.string,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    hereAppId: 'dNFhPGrUNEf7jaxFuYKT',
    hereAppCode: 'IoOntFjgxyzphwqosAyCcA',
    center: [52.50697,13.2843072],
    country: 'DEU',
    radius: 25000,
    onSelect: () => {},
    notFoundMessage: 'Adresse konnte nicht gefunden werden.',
    placeholder: ''
  }

  constructor() {
    super();

    this.state = {
      results: [],
      loading: false
    }

    this.onInput = _debounce(this.onInput, 100);
    this.request = null;    
  }

  onInput = (inputValue) => {    
    if (!inputValue) {
      return this.setState({ results: [] });
    } else {
      if (this.request) {
        this.request.abort();
      }

      this.setState({ loading: true })

      const requestUrl = getSuggestUrl({
        query: inputValue,
        app_id: this.props.hereAppId,
        app_code: this.props.hereAppCode,
        country: this.props.country,
        center: this.props.center,
        radius: this.props.radius
      });

      this.request = $.getJSON(requestUrl, res => {
        this.setState({ results: parseGeoCoderResult(res), loading: false });
      });
    }
  }

  onSelect = (resultItem) => {
    this.setState({ loading: true, results: [] });

    const requestUrl = getGeoCodingUrl({
      locationId: resultItem.locationId,
      app_id: this.props.hereAppId,
      app_code: this.props.hereAppCode
    });

    $.getJSON(requestUrl, result => {
      this.props.onSelect(result);
      this.setState({ loading: false });
    });
  }

  render() {
    return (
      <Search
        results={this.state.results}
        loading={this.state.loading}
        onInput={this.onInput}
        onSelect={this.onSelect}
        notFoundMessage={this.props.notFoundMessage}
        placeholder={this.props.placeholder}
      />
    );
  }
}

export default Geocoder;